export default "__VITE_ASSET__DqA_x5gn__"